import { connect, useSelector } from "react-redux";
import {
    CButton,
    CButtonGroup,
    CCol, CForm,
    CFormInput,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import { useEffect, useState } from "react";
import * as api from "../../../api/api";
import { selectedActions } from "../../../redux-store/actions/selected";
import { storeActions } from "../../../redux-store/actions/store";

const BrandListWhere = (props) => {
    const { user } = useSelector((props) => props.account);
    const [company, setCompany] = useState([{ cmpCd: "", cmpNm: "전체" }]);
    const [brand, setBrand] = useState([{ brandCd: "", brandNm: "전체" }]);

    useEffect(() => {
        getCompany();
    }, []);

    const getCompany = async () => {
        if (user.cmpCd !== null) {
            const { data: result } = await api.getCompany(user.cmpCd);
            const { responseBody, responseCode, responseMessage } = result;
            if (responseCode === "200") {
                // 성공
                setCompany([responseBody]);
                props.onSelect(user.cmpCd, "C");
                props.setSelectCmpCd(user.cmpCd);
                getBrand(user.cmpCd);
            }
        } else {
            const params = {
                userId: user.userId
            }

            const { data: result } = await api.getCompanyList(params);
            const { responseBody, responseCode, responseMessage } = result;
            if (responseCode === "200") {
                // 성공
                setCompany([{ cmpCd: "", cmpNm: "전체" }]);
                setCompany((state) => state.concat(responseBody));

                console.log(">>>>>> selected cmp : ", props.selected.cmpCd);
            }
        }
    };

    const getBrand = async (cmpCd) => {
        if (user.brandCd !== null) {
            const { data: result } = await api.getBrand(user.cmpCd, user.brandCd);
            const { responseBody, responseCode, responseMessage } = result;
            if (responseCode === "200") {
                // 성공
                props.onSelect(user.brandCd, "B");
                props.setSelectBrandCd(user.brandCd);
                setBrand([responseBody]);

                //getStore(user.cmpCd, user.brandCd);
            }
        } else {
            const { data: result } = await api.getBrandList(cmpCd);
            const { responseBody, responseCode, responseMessage } = result;
            if (responseCode === "200") {
                // 성공
                setBrand([{ brandCd: "", brandNm: "전체" }]);
                setBrand((state) => state.concat(responseBody));

                if (props.selected.brandCd) {
                    //getStore(props.selected.cmpCd, props.selected.brandCd);
                }
            }
        }
    };

    const handleSelect = (e, value) => {
        if (value === "C") {
            props.onSelect(e.target.value, "C");
            props.setSelectCmpCd(e.target.value);
            setBrand([{ brandCd: "", brandNm: "전체" }]);
            getBrand(e.target.value);
        } else if (value === "B") {
            props.onSelect(e.target.value, "B");
            props.setSelectBrandCd(e.target.value);
            //getStore(props.selected.cmpCd, e.target.value);
        }
    };

    return (
        <>
            <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                <CCol xs={12}>
                    <CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
                        <CInputGroupText style={{ width: 80 }}>운영사</CInputGroupText>
                        <CFormSelect id="company"
                                     value={user.cmpCd ? user.cmpCd : props.selected.cmpCd}
                                     onChange={(e) => handleSelect(e, "C")}>
                            {company.map((item, index) => {
                                return (
                                    <option key={index} value={item.cmpCd}>{item.cmpNm}</option>
                                );
                            })}
                        </CFormSelect>
                    </CInputGroup>
                </CCol>
                <CCol xs={12}>
                    <CInputGroup size="sm" className={"mb-1"} style={{height: 35}}>
                        <CInputGroupText style={{ width: 80 }}>휴게소</CInputGroupText>
                        <CFormSelect id="brand"
                                     value={user.brandCd ? user.brandCd : props.selected.brandCd}
                                     onChange={(e) => handleSelect(e, "B")}>
                            {brand.map((item, index) => {
                                return (
                                    <option key={index} value={item.brandCd}>{item.brandNm}</option>
                                );
                            })}
                        </CFormSelect>
                    </CInputGroup>
                </CCol>

            </CForm>
        </>
    );
};

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectCmpCd: (cmpCd) => {
            dispatch(selectedActions.setSelectCmpCd(cmpCd));
        },
        setSelectBrandCd: (brandCd) => {
            dispatch(selectedActions.setSelectBrandCd(brandCd));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BrandListWhere);
